import React, { useEffect, useState } from "react";

import Readings from "./Readings.jsx";

import HeroSection from "../utilities/HeroSection.jsx";
import axiosInstance from "../utilities/axiosInstance.js";


function ReadingList({ banners, isLoading, error }) {
  const [readings, setReadings] = useState(null);
  const readingsBanners = banners
    ? banners["who we are - our spirituality"]
    : [];
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    axiosInstance.get(`readings/`).then((response) => {
      // Get today's date
      const today = new Date();

      // Get yesterday's date
      const yesterday = new Date(today);
      yesterday.setDate(today.getDate() - 1);

      // Get tomorrow's date
      const tomorrow = new Date(today);
      tomorrow.setDate(today.getDate() + 1);

      const filteredReadings = response.data?.filter((reading) => {
        const readingDate = new Date(reading.Reading_Date);
        return (
          // readingDate.toDateString() === yesterday.toDateString() ||
          readingDate.toDateString() === today.toDateString()
          // || readingDate.toDateString() === tomorrow.toDateString()
        );
      });
      // console.log(filteredReadings);
      setReadings(filteredReadings);
    });
  }, []);

  return (
    <>
      <HeroSection
        banners={readingsBanners}
        isLoading={isLoading}
        error={error}
      />
      <Readings readings={readings} />
    </>
  );
}

export default ReadingList;
